import {
  useListeningQueue,
  ListeningQueueProvider,
} from './ListeningQueueContext';

export default useListeningQueue;

export { ListeningQueueProvider };
